export default __webpack_public_path__ + "static/media/check-circle.5ffe542b.svg";